import {useState, createContext, useContext, useEffect} from "react";
import {useAppConfig} from "./AppConfigProvider";

let ModuleConfigContext = createContext(null);

export default function ModuleConfigProvider({name, path, icon = null, children}) {
    const {setModulePath} = useAppConfig();

    const [moduleFilter, setModuleFilterInternal] = useState(null);

    const addToModuleFilter = filter => {
        setModuleFilterInternal({...moduleFilter, ...filter});
    };

    useEffect(() => {
        if (path) {
            setModulePath([{name, path, icon}]);
        }
        return () => {
            setModulePath([]);
        };
    }, []);

    let value = {
        moduleFilter,
        addToModuleFilter,
        path,
    };

    return (
        <ModuleConfigContext.Provider value={value}>
            {children}
        </ModuleConfigContext.Provider>
    );
}

function useConfigModule() {
    return useContext(ModuleConfigContext);
}

export {useConfigModule};
